import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth, API } from '../App';
import { t } from '../i18n';
import { StatTile, Sparkline, RouteBreakdown } from '../components/DashboardBits';

export default function DeptDashboardPage() {
  const { lang, auth } = useAuth();
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/dashboard/dept`).then(r => setD(r.data));
  }, []);

  if (!d) return <div className="space-y-3">{[...Array(4)].map((_, i) => <div key={i} className="skeleton h-24 rounded-sm" />)}</div>;

  const savedThisMonth = (d.by_route['FAQ'] || 0) + (d.by_route['Semantic Cache'] || 0) +
                        (d.by_route['Metadata DB'] || 0) + (d.by_route['Summary Lookup'] || 0);
  const wouldHaveCost = savedThisMonth * 1.04; // Sonnet baseline

  return (
    <div className="fade-up" data-testid="dept-dashboard">
      <div className="data-label accent-line text-[#DDA079] mb-3">{t(lang, 'nav.dept_dashboard')}</div>
      <h1 className="font-headings text-4xl text-white mb-2">{auth.user.department} · Department Overview</h1>
      <p className="text-slate-400 mb-8">Cost transparency for queries originating from your department.</p>

      <div className="grid grid-cols-4 gap-4 mb-6">
        <StatTile testid="stat-queries" label={t(lang, 'common.last30')} value={d.total_queries} sub="queries" accent="text-white" />
        <StatTile testid="stat-free" label="Free routes" value={`${d.free_pct}%`} sub={`${d.free_queries} of ${d.total_queries}`} accent="text-emerald-400" />
        <StatTile testid="stat-spend" label="AI spend (30d)" value={`₹${d.total_spend_inr.toFixed(2)}`} sub={`today ₹${d.today_spend_inr.toFixed(2)}`} accent="text-[#DDA079]" />
        <StatTile testid="stat-saved" label="Avoided premium spend" value={`₹${wouldHaveCost.toFixed(2)}`} sub={`${savedThisMonth} free queries × Sonnet ₹1.04`} accent="text-emerald-400" />
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="v-card p-5">
          <div className="data-label mb-1">Spend, last 14 days</div>
          <div className="font-headings text-3xl text-white">₹{d.total_spend_inr.toFixed(2)}</div>
          <Sparkline data={d.sparkline} />
        </div>
        <div className="v-card p-5">
          <div className="data-label mb-3">Route distribution (30d)</div>
          <RouteBreakdown byRoute={d.by_route} />
        </div>
      </div>

      <div className="v-card p-5">
        <div className="data-label mb-3">Top questions in your department</div>
        {d.top_queries.length === 0 ? (
          <div className="text-slate-500 text-[13px]">{t(lang, 'common.empty')}</div>
        ) : (
          <div className="space-y-2">
            {d.top_queries.map((q, i) => (
              <div key={i} className="flex justify-between items-center border-b border-white/5 py-2">
                <span className="text-white text-[13px] truncate flex-1">{q.question}</span>
                <span className="font-mono text-[11px] text-slate-400 ml-3">{q.count} asks</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
